import { render, staticRenderFns } from "./ExamFreedomRule.vue?vue&type=template&id=2353d45e&scoped=true"
import script from "./ExamFreedomRule.vue?vue&type=script&lang=js"
export * from "./ExamFreedomRule.vue?vue&type=script&lang=js"
import style0 from "./ExamFreedomRule.vue?vue&type=style&index=0&id=2353d45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353d45e",
  null
  
)

export default component.exports